<template>
  <section v-if="items.length" class="announcements" aria-label="站点公告">
    <el-carousel height="350px" :autoplay="items.length > 1 && !reduceMotion" :interval="6000" :arrow="items.length > 1 ? 'hover' : 'never'" :indicator-position="items.length > 1 ? 'outside' : 'none'">
      <el-carousel-item v-for="item in items" :key="item.id">
        <router-link class="announcement" :to="'/essay/' + item.publicId">
          <img :src="item.img" :alt="item.title" @error="imageFailed">
          <div class="caption"><small>站点公告</small><h2>{{ item.title }}</h2><p>{{ item.description }}</p><span>阅读详情 →</span></div>
        </router-link>
      </el-carousel-item>
    </el-carousel>
  </section>
</template>
<script>
import { announcementRequest } from '@/api/essay/announcements'
export default {
  data: () => ({ items: [], reduceMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches }),
  created() { announcementRequest().then(items => { this.items = items || [] }).catch(() => {}) },
  methods: { imageFailed(event) { event.target.style.visibility = 'hidden' } }
}
</script>
<style scoped>
.announcements{width:800px;max-width:100%;margin:0 0 20px;background:#fffbf5;border:1px solid #e9dfd1;border-radius:14px;overflow:hidden}
.announcement{display:flex;flex-direction:column;height:100%;color:#30241c;text-decoration:none;background:#fffbf5}
.announcement>img{display:block;width:100%;height:205px;object-fit:cover;background:#efe5d7}
.caption{padding:14px 22px;position:relative;flex:1}.caption small{font-size:11px;letter-spacing:2px;color:#9e5229}.caption h2{font-size:20px;margin:5px 0}.caption p{font-size:14px;line-height:1.5;color:#796755;margin:4px 0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;padding-right:90px}.caption>span{position:absolute;right:22px;bottom:18px;font-size:13px;color:#9e5229}
@media(max-width:767px){.announcements{width:100%;border-radius:0}.caption{padding:12px 16px}.caption h2{font-size:18px}}
</style>
